const LocationPinIcon = ({ className, style }: { className?: string; style?: any }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.0001 2.08331C6.09425 2.08331 2.91675 5.26081 2.91675 9.16665C2.91675 13.3191 6.77425 15.8674 9.32675 17.5533L9.76841 17.8467C9.83841 17.8933 9.91924 17.9166 9.99924 17.9166C10.0792 17.9166 10.1601 17.8933 10.2301 17.8467L10.6717 17.5533C13.2242 15.8674 17.0817 13.3191 17.0817 9.16665C17.0834 5.26081 13.9059 2.08331 10.0001 2.08331ZM10.0001 11.25C8.84925 11.25 7.91675 10.3175 7.91675 9.16665C7.91675 8.01581 8.84925 7.08331 10.0001 7.08331C11.1509 7.08331 12.0834 8.01581 12.0834 9.16665C12.0834 10.3175 11.1509 11.25 10.0001 11.25Z"
        fill="#C48859"
      />
    </svg>
  );
};

export default LocationPinIcon;
